"use client";

import { useAbout } from "@/hooks/usePublicData";
import { useLocale } from "next-intl";
import AboutCTA from "./AboutCTA";
import AboutGallery from "./AboutGallery";
import AboutHero from "./AboutHero";
import AboutIntro from "./AboutIntro";
import AboutStats from "./AboutStats";
import AboutStory from "./AboutStory";
import AboutTeam from "./AboutTeam";
import AboutValues from "./AboutValues";
import AboutVisionMission from "./AboutVisionMission";

export default function AboutClient() {
  const locale = useLocale();
  const isAr = locale === "ar";
  const { data: about, isLoading } = useAbout();

  if (isLoading) {
    return (
      <div className="najdi bg-background min-h-screen" dir={isAr ? "rtl" : "ltr"}>
        <div className="w-full aspect-[4/3] min-h-[320px] md:aspect-[8/3] md:min-h-0 bg-clay-100/50 animate-pulse" />
        <div className="container mx-auto px-6 py-16 space-y-6">
          <div className="h-6 w-2/3 mx-auto rounded bg-clay-100/50 animate-pulse" />
          <div className="h-4 w-full rounded bg-clay-100/40 animate-pulse" />
          <div className="h-4 w-5/6 mx-auto rounded bg-clay-100/40 animate-pulse" />
        </div>
      </div>
    );
  }

  if (!about) {
    return (
      <div className="najdi bg-background min-h-[50vh] flex items-center justify-center text-ink-500" dir={isAr ? "rtl" : "ltr"}>
        {isAr ? "تعذّر تحميل الصفحة" : "Couldn't load the page"}
      </div>
    );
  }

  // Section-visibility toggles controlled from the dashboard.
  const s = about.sections || {};
  const on = (key: string, dflt = true) => (s[key] === undefined ? dflt : !!s[key]);

  return (
    <div className="najdi bg-background text-ink-900" dir={isAr ? "rtl" : "ltr"}>
      <AboutHero about={about} isAr={isAr} />
      {on("intro") && <AboutIntro about={about} isAr={isAr} />}
      {on("stats") && <AboutStats about={about} isAr={isAr} />}
      {on("visionMission") && <AboutVisionMission about={about} isAr={isAr} />}
      {on("story") && <AboutStory about={about} isAr={isAr} />}
      {on("values") && <AboutValues about={about} isAr={isAr} />}
      {on("gallery", false) && <AboutGallery about={about} isAr={isAr} />}
      {on("team", false) && <AboutTeam about={about} isAr={isAr} />}
      {on("cta") && <AboutCTA about={about} isAr={isAr} />}
    </div>
  );
}
